export class ForgeProjectSection {
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
        this.sortOrder = model.sortOrder;
        this.projectId = model.projectId;
    }
    toRemote() {
        return Object.assign(Object.assign({}, this), { createdAt: this.createdAt.toISOString(), updatedAt: this.updatedAt.toISOString() });
    }
}
